module.exports=function(scope){ return `String deviceLicenseKeyIdentifier = "<THIS_IDENTIFIER_WILL_DEPEND_ON_YOUR_DEVELOPER_ACCOUNT>";

// Initialize the FaceTec SDK with your SDK Key
// @param - context - The current activity that's launching the User Session
// @param - deviceLicenseKeyIdentifier - This is your Device SDK Key Identifier. You can get your Device SDK Key Identifier here: https://dev.facetec.com/zoomsdk/#/account
// @param - ZoomSDK.InitializeCallback -  Optional callback to notify caller when FaceTec SDK initialization has completed
//
ZoomSDK.initialize(context, deviceLicenseKeyIdentifier, new ZoomSDK.InitializeCallback() {
    @Override
    public void onCompletion(boolean successful) {
        if(!successful) {
            handleUnsuccessfulInit();
            return;
        }

        // Ready to launch the User Session!
    }
});`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/android/00-initialize-dev.java.tpl